import { BezierEdge, type EdgeProps } from '@xyflow/react';
import { FC } from 'react';

export const SmartBezierEdge: FC<EdgeProps> = (props) => {
  return <BezierEdge {...props} />;
};
